import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WizardStepperEnum} from '@shared/components/wizard-stepper/enum/wizard-stepper.enum';

@Component({
    selector: 'app-wizard-stepper',
    templateUrl: './wizard-stepper.component.html',
    styleUrls: ['./wizard-stepper.component.scss']
})
export class WizardStepperComponent implements OnInit, OnChanges {
    @Input() titleList: string[] | undefined;
    @Input() numberOfSteps = 0;
    @Input() wizardStep: number | undefined;
    @Input() stepTextGapOff: boolean;
    currentStep = 0;
    stepperObjectArray = [];

    ngOnInit(): void {
        if (this.stepperObjectArray && this.stepperObjectArray.length > 0) {
            this.markCurrent();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.prepareSteps();
        this.currentStep = this.wizardStep - 1;
        this.markSteps();
    }

    markSteps(): void {
        for (let i = 0; i < this.stepperObjectArray.length; i++) {
            if (i < this.currentStep) {
                this.stepperObjectArray[i].status = WizardStepperEnum.COMPLETED;
            } else if (i === this.currentStep) {
                this.stepperObjectArray[i].status = WizardStepperEnum.CURRENT;
            } else {
                this.stepperObjectArray[i].status = WizardStepperEnum.UNMARKED;
            }
        }
    }

    markCurrent(): void {
        if (this.currentStep > -1 && this.currentStep < this.stepperObjectArray.length) {
            this.stepperObjectArray[this.currentStep].status = WizardStepperEnum.CURRENT;
        }
    }

    private prepareSteps(): void {
        this.stepperObjectArray = [];
        for (let i = 0; i < this.numberOfSteps; i++) {
            const step = {
                order: i,
                label: this.titleList ? this.titleList[i] : undefined,
                status: WizardStepperEnum.UNMARKED
            };
            this.stepperObjectArray.push(step);
        }
    }
}
